/** @format */

import {isBefore, isEqual, format as formatDate, addDays, isAfter} from 'date-fns';
import {ru} from 'date-fns/locale';

export const formatDateToString = (date: Date, format: string): string => {
  return formatDate(date, format, {locale: ru});
};

export interface OptionsGetDateArray {
  startDate: string | Date;
  endDate: string | Date;
  format: string;
}

/**
 * Соберет все даты периода в массиве
 */

export const getDateArray = ({startDate, endDate, format}: OptionsGetDateArray): string[] => {
  const dateArray: string[] = [];
  const endDateConverted = typeof endDate === 'string' ? new Date(endDate) : endDate;

  let currentDate = typeof startDate === 'string' ? new Date(startDate) : startDate;

  while (isBefore(currentDate, endDateConverted) || isEqual(currentDate, endDateConverted)) {
    const formattedDate = formatDateToString(currentDate, format);
    dateArray.push(formattedDate);
    currentDate = addDays(currentDate, 1);
  }

  return dateArray;
};

export interface OptionsIsInTheRange {
  startOn: Date;
  endOn?: Date;
  currentDate: Date;
}

/**
 * Вернёт true, если текущая дата входит в обозначенный период
 * @param startOn
 * @param endOn
 * @param currentDate
 */

export const isInTheRange = ({startOn, endOn, currentDate}: OptionsIsInTheRange): boolean => {
  if (!endOn) {
    return isAfter(currentDate, startOn) || isEqual(currentDate, startOn);
  }

  return !isBefore(currentDate, startOn) && !isAfter(currentDate, endOn);
};

/**
 * Вернёт название месяца на русском в родительном падеже
 * @param month
 */

export const getMonthGenitive = (month: number): string => {
  switch (month) {
    case 0:
      return 'января';
    case 1:
      return 'февраля';
    case 2:
      return 'марта';
    case 3:
      return 'апреля';
    case 4:
      return 'мая';
    case 5:
      return 'июня';
    case 6:
      return 'июля';
    case 7:
      return 'августа';
    case 8:
      return 'сентября';
    case 9:
      return 'октября';
    case 10:
      return 'ноября';
    case 11:
      return 'декабря';
    default:
      throw new Error('Wrong month number');
  }
};
